import FootballState from "../../../../../sports/football/state/football-state";
import FootballStringifier from "../../../../stringifiers/football-stringifier";
import { FragmentSerializer } from "./FragmentSerializer";

export class DriveFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.StartDrive;
    }

    getRawFragment(play, serializationContext, startDrive) {
        const ms = startDrive?.startTime?.milliseconds;
        const rawPlay = `{DRIVE}:${FootballStringifier.milisecondsToMMSS(ms)}`;
        return rawPlay;
    }
}
